import { LicenseProductIdEnum } from '@nirvana/shared/license-helper';

export class LicensingConstants {
  public static PartnerIdLength = 32;

  /**
   * @const int The number of seconds that has to pass since last manually sync
   */
  public static MinSecondsBetweenManualLicenseRefresh = 900; // 15 * 60

  public static BundleLicenses = [
    LicenseProductIdEnum.ProductIdSos,
    LicenseProductIdEnum.ProductIdOfficeSecurityPack,
    LicenseProductIdEnum.ProductIdBusinessSecurityPack,
    LicenseProductIdEnum.ProductIdEnterprisePoolsAbsPack,
    LicenseProductIdEnum.ProductIdNextGen,
    LicenseProductIdEnum.ProductIdNextGenExtended,
    LicenseProductIdEnum.ProductIdAtd,
    LicenseProductIdEnum.ProductIdEarlyAccess,
    LicenseProductIdEnum.ProductIdCoreOnlineProduct,
    LicenseProductIdEnum.ProductIdMdrPremium,
    LicenseProductIdEnum.ProductIdXdrBundle
  ];

  public static BundleLicensesWithoutServerLimit = [
    LicenseProductIdEnum.ProductIdEnterprisePoolsAbsPack,
    LicenseProductIdEnum.ProductIdNextGenExtended,
    LicenseProductIdEnum.ProductIdMdr,
    LicenseProductIdEnum.ProductIdMdrPlus,
    LicenseProductIdEnum.ProductIdXdrBundle,
  ];

  public static AddonsWithUsage = [
    LicenseProductIdEnum.ProductIdPatchManagement,
    LicenseProductIdEnum.ProductIdVolumeEncryption,
    LicenseProductIdEnum.ProductIdEmailSecurity,
    LicenseProductIdEnum.ProductIdMobileSecurity,
    LicenseProductIdEnum.ProductIdIntegrityMonitorAddon,
    LicenseProductIdEnum.ProductIdNadAndEraAddon,
    LicenseProductIdEnum.ProductIdWebAccessAndDeviceControlAddon,
    LicenseProductIdEnum.ProductIdPhasrAddon,
  ];

  public static BundleLicenseWithoutExchangeMailboxes = [
    LicenseProductIdEnum.ProductIdOfficeSecurityPack,
    LicenseProductIdEnum.ProductIdCoreOnlineProduct,
  ];
}
